import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CallCalling = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/linear/call-calling">
        <g id="call-calling">
          <g id="call-calling_2">
            <path
              id="Vector"
              d="M14.6467 12.2197C14.6467 12.4597 14.5934 12.7063 14.48 12.9463C14.3667 13.1863 14.22 13.413 14.0267 13.6263C13.7 13.9863 13.34 14.2463 12.9334 14.413C12.5334 14.5797 12.1 14.6663 11.6334 14.6663C10.9534 14.6663 10.2267 14.5063 9.46004 14.1797C8.69337 13.853 7.92671 13.413 7.16671 12.8597C6.40004 12.2997 5.67337 11.6797 4.98004 10.993C4.29337 10.2997 3.67337 9.57301 3.12004 8.81301C2.57337 8.05301 2.13337 7.29301 1.81337 6.53967C1.49337 5.77967 1.33337 5.05301 1.33337 4.35967C1.33337 3.90634 1.41337 3.47301 1.57337 3.07301C1.73337 2.66634 1.98671 2.29301 2.34004 1.95967C2.76671 1.53967 3.23337 1.33301 3.72671 1.33301C3.91337 1.33301 4.10004 1.37301 4.26671 1.45301C4.44004 1.53301 4.59337 1.65301 4.71337 1.82634L6.26004 4.00634C6.38004 4.17301 6.46671 4.32634 6.52671 4.47301C6.58671 4.61301 6.62004 4.75301 6.62004 4.87967C6.62004 5.03967 6.57337 5.19967 6.48004 5.35301C6.39337 5.50634 6.26671 5.66634 6.10671 5.82634L5.60004 6.35301C5.52671 6.42634 5.49337 6.51301 5.49337 6.61967C5.49337 6.67301 5.50004 6.71967 5.51337 6.77301C5.53337 6.82634 5.55337 6.86634 5.56671 6.90634C5.68671 7.12634 5.89337 7.41301 6.18671 7.75967C6.48671 8.10634 6.80671 8.45967 7.15337 8.81301C7.51337 9.16634 7.86004 9.49301 8.21337 9.79301C8.56004 10.0863 8.84671 10.2863 9.07337 10.4063C9.10671 10.4197 9.14671 10.4397 9.19337 10.4597C9.24671 10.4797 9.30004 10.4863 9.36004 10.4863C9.47337 10.4863 9.56004 10.4463 9.63337 10.373L10.14 9.87301C10.3067 9.70634 10.4667 9.57967 10.62 9.49967C10.7734 9.40634 10.9267 9.35967 11.0934 9.35967C11.22 9.35967 11.3534 9.38634 11.5 9.44634C11.6467 9.50634 11.8 9.59301 11.9667 9.70634L14.1734 11.273C14.3467 11.393 14.4667 11.533 14.54 11.6997C14.6067 11.8663 14.6467 12.033 14.6467 12.2197Z"
              stroke="#32323C"
              strokeWidth="1.5"
              strokeMiterlimit="10"
            />
            <path
              id="Vector_2"
              d="M12.3333 5.99935C12.3333 5.59935 12.02 4.98602 11.5533 4.48602C11.1267 4.02602 10.56 3.66602 10 3.66602"
              stroke="#32323C"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector_3"
              d="M14.6667 5.99967C14.6667 3.41967 12.58 1.33301 10 1.33301"
              stroke="#32323C"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

CallCalling.displayName = 'CallCalling';
